import { NgModule } from '@angular/core';
// application-pipes.module.ts
// other imports
import {
  CapitalizeWords,
  DashWords,
  UnderscoreWords,
  Moment,
  PhoneNumber,
  SafePipe,
  Month,
  EscapeHtmlPipe,
  Has,
  IsMobile,
  IsDesktop,
} from './directives/application-pipes.directive';

@NgModule({
  imports: [
    // dep modules
  ],
  declarations: [
    SafePipe,
    CapitalizeWords,
    DashWords,
    UnderscoreWords,
    PhoneNumber,
    Moment,
    Month,
    EscapeHtmlPipe,
    Has,
    IsMobile,
    IsDesktop,
  ],
  exports: [
    SafePipe,
    CapitalizeWords,
    PhoneNumber,
    Moment,
    Month,
    EscapeHtmlPipe,
    Has,
    IsMobile,
    IsDesktop,
    DashWords,
    UnderscoreWords,
  ],
})
export class ApplicationPipesModule {}
